import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function TestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    name: 'Roberto M.',
    age: '47 años',
    location: 'Buenos Aires',
    quote: 'Después de 15 años de oficina, tenía la espalda destruida. En 8 semanas con el protocolo, dejé los analgésicos. Ahora levanto a mis hijos sin miedo.',
    result: 'Eliminó dolor crónico de espalda'
  }, {
    name: 'Marcela S.',
    age: '52 años',
    location: 'Córdoba',
    quote: 'Pensé que era tarde para mí. El programa me demostró que la fuerza no tiene edad. Recuperé la confianza y la energía que creía perdida.',
    result: 'Recuperó autonomía física'
  }, {
    name: 'Diego P.',
    age: '43 años',
    location: 'Rosario',
    quote: 'Solo 90 minutos por semana y los resultados son brutales. Mi médico no podía creer los cambios en mi densidad ósea. Esto es inversión real.',
    result: 'Mejoró densidad ósea 18%'
  }];
  return <section ref={ref} className="w-full bg-bg-primary py-20 px-4 sm:px-6 lg:px-8" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-199">
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-text-primary mb-6" data-id="element-200">
            Argentinos que ya{' '}
            <span className="text-accent-bronze" data-id="element-201">blindaron su futuro</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto font-body" data-id="element-202">
            No son atletas. Son profesionales como vos que decidieron invertir
            en su estructura.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-203">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-bg-secondary border border-accent-bronze/20 rounded-sm p-8 hover:border-accent-bronze/40 transition-colors duration-300" data-id="element-204">
              <div className="flex items-center gap-1 mb-4" data-id="element-205">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-accent-gold fill-accent-gold" data-id="element-206" />)}
              </div>

              <QuoteIcon className="w-8 h-8 text-accent-bronze/30 mb-4" data-id="element-207" />

              <blockquote className="text-text-secondary font-body leading-relaxed mb-6" data-id="element-208">
                "{testimonial.quote}"
              </blockquote>

              <div className="border-t border-accent-bronze/20 pt-4" data-id="element-209">
                <div className="flex items-center justify-between mb-2" data-id="element-210">
                  <div data-id="element-211">
                    <p className="font-heading text-xl text-text-primary" data-id="element-212">
                      {testimonial.name}
                    </p>
                    <p className="text-text-muted text-sm font-body" data-id="element-213">
                      {testimonial.age} • {testimonial.location}
                    </p>
                  </div>
                </div>
                <div className="bg-accent-bronze/10 border border-accent-bronze/20 rounded-sm px-3 py-2 mt-3" data-id="element-214">
                  <p className="text-accent-bronze text-sm font-body font-semibold" data-id="element-215">
                    {testimonial.result}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-216">
          <div className="inline-flex items-center gap-3 bg-bg-secondary border border-accent-bronze/20 rounded-sm px-6 py-4" data-id="element-217">
            <div className="flex -space-x-2" data-id="element-218">
              {[...Array(5)].map((_, i) => <div key={i} className="w-10 h-10 rounded-full bg-accent-bronze border-2 border-bg-secondary" data-id="element-219" />)}
            </div>
            <div className="text-left" data-id="element-220">
              <p className="text-text-primary font-body font-semibold" data-id="element-221">
                +2.400 personas
              </p>
              <p className="text-text-muted text-sm font-body" data-id="element-222">
                ya aplicaron el protocolo
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}